import { jsx as e, Fragment as s, jsxs as c } from "@emotion/react/jsx-runtime";
import { Cell as l } from "../Cell/Cell.js";
import { StyledLoadingRow as d, StyledSkeleton as p } from "./SkeletonRows.styled.js";
const g = ({
  selectable: t,
  rows: n,
  cols: m
}) => {
  const a = Array.from({
    length: n
  }, (o, r) => r), i = Array.from({
    length: m
  }, (o, r) => r);
  return /* @__PURE__ */ e(s, { children: a.map((o) => /* @__PURE__ */ c(d, { role: "row", id: `skeleton-${o}`, children: [
    t ? /* @__PURE__ */ e(l, {}) : null,
    i.map((r) => /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(p, { variant: "line" }) }, r))
  ] }, o)) });
};
export {
  g as SkeletonRows
};
